<template>
  <div style="padding: 0.5em">
    <el-form :model="form" ref="form" label-position="left" label-width="0" class="card-box-com">
      <h3 class="title">{{systemName}}</h3>
      <el-table
        :data="tableData"
        border
        height = "700"
        style="width: 100%">
        <el-table-column
          prop="reserved_status"
          width="100"
          label="確認">
          <template slot-scope="scope">
            <el-select v-model="scope.row.reserved_status" clearable placeholder="選択" @change="changeOption(scope.$index, scope)">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="reserved_id"
          width="130"
          label="受付番号">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="会社名"
          show-overflow-tooltip
          width="140">
        </el-table-column>
        <el-table-column
          prop="truck_comp_name"
          label="運送会社名"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="truck_type_name"
          label="車両"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="truck_type_other"
          label="車両その他"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="reserved_ymd"
          label="搬入日時"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="item_type_name"
          label="搬入品目"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="item_other"
          label="搬入品目その他"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="truck_tel"
          label="夜間連絡先"
          show-overflow-tooltip
          width="164">
        </el-table-column>
        <el-table-column
          prop="prepare"
          label="備考"
          show-overflow-tooltip
          width="164">
        </el-table-column>
      </el-table>
      <div class = "pagination">
        <el-pagination
          background
          @current-change="changePage"
          layout="prev, pager, next"
          :page-size="limit"
          :current-page="currentPage"
          :total="total">
        </el-pagination>
      </div>
      <el-row >
        <el-col :span="3">
          <el-form-item >
            <el-button type="danger" class="btn-left" @click.native.prevent="previousDay()">前　日</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item >
            <el-button type="danger" class="btn-left" @click.native.prevent="sameDay()">当　日</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="15 ">
          <el-form-item >
            <el-button type="danger" class="btn-left" @click.native.prevent="handleSubmit2('form')">確　認</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item >
            <el-button type="danger" class="btn-left" @click.native.prevent="back()"><i class="el-icon-caret-right"style="color: white;"></i> 戻　る </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'
  import timeChe from '../../assets/js/timeChe'

  export default {
    data () {
      return {
        systemName: '社内台貫作業者向け 会社別搬入情報一覧画面',
        fromDate: '',
        toDate: '',
        userId: '',
        total: null,
        limit: 10,
        newDate: '',
        currentPage: null,
        tableData: [],
        tableData1: {},
        form: {
          status: 0,
          value: ''
        },
        options: [{
          value: '0',
          label: '取消'
        },
        {
          value: '2',
          label: '〇'
        }]
      }
    },
    methods: {
      previousDay() {
        this.newDate = this.reduceDays(new Date(), 1)
        var month0 = (this.newDate.getMonth() + 1) < 10 ? '0' + (this.newDate.getMonth() + 1).toString() : (this.newDate.getMonth() + 1).toString()
        var day0 = this.newDate.getDate() < 10 ? '0' + this.newDate.getDate().toString() : this.newDate.getDate().toString()
        var fromDate = this.newDate.getFullYear().toString() + month0 + day0
        // this.tableData = []
        this.$router.push({ path: this.$route.path, query: { fromDate: fromDate, toDate: fromDate, userId: this.userId, currentPage: 1 }})
      },
      sameDay() {
        this.newDate = new Date()
        var month0 = (this.newDate.getMonth() + 1) < 10 ? '0' + (this.newDate.getMonth() + 1).toString() : (this.newDate.getMonth() + 1).toString()
        var day0 = this.newDate.getDate() < 10 ? '0' + this.newDate.getDate().toString() : this.newDate.getDate().toString()
        var fromDate = this.newDate.getFullYear().toString() + month0 + day0
        // this.tableData = []
        this.$router.push({ path: this.$route.path, query: { fromDate: fromDate, toDate: fromDate, userId: this.userId, currentPage: 1 }})
      },
      reduceDays(date, value) {
        // date.setDate(date.getDate() + value)
        var newDate = new Date(date.getTime() - 3600 * 1000 * 24 * value)
        return newDate
      },
      handleSubmit2(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        let data = {}
        var date = new Date()
        data.dataList = this.tableData
        data.userId = this.$route.query.userId
        var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
        var day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
        var upDate = date.getFullYear().toString() + month + day
        data.upDate = upDate
        this.apiPost('daikan/CompanyList/confirmHandle', data).then((res) => {
          this.handelResponse(res, (data) => {
            if (res.code != 200) {
              this.loading = !this.loading
              this.handleError(res)
            } else {
              if (data.dataCount === '0') {
                _g.toastMsg('error', '変更がありません！')
              } else {
                _g.toastMsg('success', '変更のデータを更新しました！')
              }
            }
          })
        })
      },
      changeOption(index, scope) {
        if (scope.row.reserved_status !== '') {
          this.tableData[index].reserved_status = scope.row.reserved_status
        }
      },
      back() {
        // window.history.back()
        window.localStorage.setItem('userId', '')
        window.localStorage.setItem('loginRoot', '')
        this.resetCommonData('/daikan/login')
        _g.toastMsg('warning', 'ログアウトしました！')
      },
      changePage(currentPage) {
        let data = {}
        var date = new Date()
        data.dataList = this.tableData
        data.userId = this.$route.query.userId
        var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
        var day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
        var upDate = date.getFullYear().toString() + month + day
        data.upDate = upDate
        this.apiPost('daikan/CompanyList/confirmHandle', data).then((res) => {
          this.handelResponse(res, (data) => {
            if (res.code != 200) {
              this.loading = !this.loading
              this.handleError(res)
            } else {
              this.$router.push({ path: this.$route.path, query: { fromDate: this.fromDate, toDate: this.toDate, userId: this.userId, currentPage: currentPage }})
              if (data.dataCount === '0') {
              } else {
                _g.toastMsg('success', '変更のデータを更新しました！')
              }
            }
          })
        })
      },
      getAllUsers() {
        let data = {}
        data.fromDate = this.$route.query.fromDate
        data.toDate = this.toDate = this.$route.query.toDate
        data.userId = this.userId = this.$route.query.userId
        data.page = this.currentPage
        data.limit = this.limit
        this.apiPost('daikan/CompanyList/companyList', data).then((res) => {
          this.handelResponse(res, (data) => {
            if (res.code != 200) {
              this.loading = !this.loading
              this.handleError(res)
              this.tableData = []
            } else {
              var dataList = data.list
              var reData = dataList.forEach(function (val, index, arr) {
                if (val.reserved_status === '1') {
                  val.reserved_status = '2'
                }
                return val
              })
              let dataList1 = data.list
              var b = data.list.forEach(function (item, index, input) {
                // dataList1[index].truck_tel = item.truck_tel_siban + '-' + item.truck_tel_kaiban + '-' + item.truck_tel_kyokuban
                if ((item.truck_tel_kaiban === '' || item.truck_tel_kaiban === null) && (item.truck_tel_kyokuban === '' || item.truck_tel_kyokuban === null)) {
                  dataList1[index].truck_tel = item.truck_tel_siban
                } else {
                  dataList1[index].truck_tel = item.truck_tel_siban + '-' + item.truck_tel_kaiban + '-' + item.truck_tel_kyokuban
                }
                // if ((item.ITEM_TYPE_CD === '10011')) {
                //   dataList1[index].item_other = item.item_other
                // } else {
                //   dataList1[index].item_other = ''
                // }
                dataList1[index].reserved_ymd = item.reserved_ymd + '　' + timeChe.gettimeChe(item.reserved_time)
              })
              this.tableData = dataList1
              this.total = data.dataCount
            }
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.currentPage) {
            this.currentPage = parseInt(data.currentPage)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.fromDate) {
            this.fromDate = data.fromDate
          } else {
            this.fromDate = ''
          }
          if (data.toDate) {
            this.toDate = data.toDate
          } else {
            this.toDate = ''
          }
          if (data.userId) {
            this.userId = data.userId
          } else {
            this.userId = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.fromDate = this.$route.query.fromDate
      this.toDate = this.$route.query.toDate
      this.userId = this.$route.query.userId
      let that = this
      setInterval(function() {
        that.init()
      }, 5 * 60 * 1000)
      this.init()
    },
    mounted() {
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      // btnGroup
    },
    mixins: [http]
  }
</script>
<style>
  .card-box-com {
    padding: 2em;
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    height: 50em;
    width: 107em;
    border: 0.1em solid #8492A6;
  }
  .title {
    margin: 0px auto 1em auto;
    text-align: left;
    color: #505458;
  }
  .btn-left{
    float: right;
    width: 150px;
  }
  .pagination{
    width: 100%;
    text-align:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/daikan/companyList.vue